export default __webpack_public_path__ + "static/media/Pentair_Logo_ccw.f06dba37.svg";